import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';

import { GET_CLAIM, UPLOAD_PETOLO_CUSTOMER_CLAIM_DOCUMENTS } from '../../shared';
import { clearNewPetoloClaimFormData } from './claimFormData/newClaimFormData';

const usePetoloClaims = (claimId) => {
  const history = useHistory();

  const [uploadPetoloCustomerClaimDocuments, { data, loading, error }] = useMutation(
    UPLOAD_PETOLO_CUSTOMER_CLAIM_DOCUMENTS,
    {
      refetchQueries: claimId ? [{ query: GET_CLAIM, variables: { id: Number(claimId) } }] : [],
    }
  );

  const submitClaim = async (props) => {
    const { payload, setSelectedDocuments, setClaimSubmitted, clearFormData = true } = props || {};

    if (setClaimSubmitted) {
      setClaimSubmitted(true);
    }

    try {
      const res = await uploadPetoloCustomerClaimDocuments({
        variables: payload,
      });

      if (setSelectedDocuments) {
        setSelectedDocuments([]);
      }

      if (clearFormData) {
        clearNewPetoloClaimFormData();
      }

      const success = res?.data?.claimFilesUpload?.status === 'success';

      if (success) {
        history.push(`/user-claims/file-upload/success?count=${payload?.files?.length}`);
      } else {
        throw new Error();
      }
    } catch (err) {
      history.push('/user-claims/file-upload/failure');
    }
  };

  return [submitClaim, { data, loading, error }];
};

export default usePetoloClaims;
